import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

// One number inside a card: no box of its own, the card's dividers separate them.
export default function Figure({ label, value, tone = "default", children }: {
  label: string
  value: ReactNode
  tone?: "default" | "warning" | "success"
  children?: ReactNode
}) {
  return (
    <div className="flex min-w-0 flex-col gap-1 px-4 py-3">
      <div className="text-xs font-medium">{label}</div>
      <div
        className={cn(
          "text-xl font-semibold tabular-nums tracking-tight",
          tone === "warning" && "text-warning",
          tone === "success" && "text-success",
        )}
      >
        {value}
      </div>
      {children && <div className="flex flex-col gap-0.5 text-xs">{children}</div>}
    </div>
  )
}
